let vibe_cake_masters_modals = function( $ ) {

	let $anchors,
		$body,
		anim_speed = 400;

	let init = function() {
		$anchors = $( 'a.cake-masters-component.cake-masters-open-modal' );
		$body = $( 'body' );

		if ( $anchors.length > 0 ) {
			$anchors.each( _attach_handlers );

			$( document ).on( 'keydown', ( e ) => {

				if ( e.key === 'Escape' ) {
					close_all_modals();
				}
			} );
		}
	};

	let _attach_handlers = function() {
		let $anchor = $( this ),
			$modal = $( $anchor.attr( 'href' ) );

		$anchor.on( 'click', {modal: $modal}, _open_modal_internal );

		$modal.find( 'a.masters-close-modal' ).on( 'click', {modal: $modal}, _close_modal_internal );

		$modal.on( 'click', ( e ) => {
			if ( ! e.target.matches( '.inner-modal-content, .inner-modal-content *' ) ) {
				close_modal( $modal );
			}
		});

		$anchor.trigger( 'attached-handlers' );
	};

	let _open_modal_internal = function( e ) {
		$body.addClass( 'masters-modal-open' );

		e.data.modal.fadeIn( anim_speed );

		e.preventDefault();
	};

	let _close_modal_internal = function ( e ) {
		if ( ! $body.hasClass( 'masters-modal-open' ) ) {
			return;
		}

		$body.removeClass( 'masters-modal-open' );

		e.data.modal.fadeOut( anim_speed );

		e.data.modal.trigger( 'vibe_cake_masters_closing' );

		e.preventDefault();
	};

	let close_modal = function( $modal ) {
		if ( ! $body.hasClass( 'masters-modal-open' ) ) {
			return;
		}

		$body.removeClass( 'masters-modal-open' );

		$modal.fadeOut( anim_speed );

		$modal.trigger( 'vibe_cake_masters_closing' );
	};

	let open_modal = function( $modal ) {
		$body.addClass( 'masters-modal-open' );

		$modal.find( 'a.masters-close-modal' ).on( 'click', {modal: $modal}, _close_modal_internal );
		$body.find( '.overlay' ).on( 'click', close_all_modals );

		$modal.fadeIn( anim_speed );
	};

	let close_all_modals = function( e ) {
		if ( ! $body.hasClass( 'masters-modal-open' ) ) {
			return;
		}

		$body.removeClass( 'masters-modal-open' );

		$( '.masters-modal' ).fadeOut( anim_speed );


		$( '.masters-modal' ).trigger( 'vibe_cake_masters_closing' );


		if ( e ) {
			e.preventDefault();
		}
	};

	$( document ).ready( init );

	return {
		init: init,
		close_all_modals: close_all_modals,
		open_modal: open_modal,
		close_modal: close_modal
	};

} ( jQuery );

module.exports = vibe_cake_masters_modals;